<template>
  <div class="left-nav">
    <div class="top">
      <router-link :to="'/' + nav.path" class="top-content">
        <p>{{ nav.name }}</p>
        <p>{{ nav.component }}</p>
      </router-link>
    </div>
    <div class="nav-list">
      <ul>
        <li v-for="(item, index) in nav.children" :key="index">
          <router-link :to="'/' + nav.path + '/' + item.path" class="name">
            <div>{{ item.name }}</div>
          </router-link>
          <div v-if="item.children">
            <ul class="child-list">
              <li v-for="(citem, cindex) in item.children" :key="cindex">
                <router-link
                  :to="'/' + nav.path + '/' + item.path + '/' + citem.path"
                >
                  {{ citem.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      nav: {},
    };
  },
  computed: {
    ...mapGetters(["addRouters"]),
  },
  methods: {
    async setNav () {
      const result = await this.addRouters;
      result.map((item) => {
        if (item.id === this.$route.matched[1].meta.id) {
          this.nav = item;
        }
      })
    },
  },
  created () {
    this.setNav();
  },
  watch: {
    $route () {
      this.setNav();
    },
  },
};
</script>
<style lang="scss" scoped>
.left-nav {
  width: 200px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  margin: 20px;

  .top {
    width: 100%;
    height: 73px;
    background: $color-blue;
    display: flex;
    justify-content: space-around;
    align-items: center;
    a {
      color: #fff;
      width: 50%;
      font-size: 20px;
      height: 50px;
    }
    p {
      margin: 0;
    }
    &::before,
    &::after {
      content: "";
      display: inline-block;
      width: 15px;
      height: 15px;
      background: #fff;
      transform: rotate(45deg);
    }
  }
  .nav-list {
    width: 100%;

    ul {
      border: 1px solid #eeeeee;
      li {
        position: relative;
        .child-list {
          height: 0px;
          overflow: hidden;
          li {
            border: 1px solid #eeeeee;
          }
          :hover {
            background: #e6eef6;
            color: $color-blue;

            &::after {
              content: "";
              background: url("../../assets/icon/go.png") no-repeat 50%/100%;
              width: 14px;
              height: 14px;
              display: inline-block;
              position: absolute;
              bottom: 13px;
              right: 10px;
            }
          }
        }

        a {
          width: 100%;
          height: 40px;
          line-height: 40px;
          background: #fff;
        }
        &:hover {
          .child-list {
            height: 100% !important;
            overflow: hidden;
          }
        }
        .name:hover {
          background: #e6eef6;
          color: $color-blue;

          &::after {
            content: "";
            background: url("../../assets/icon/go.png") no-repeat 50%/100%;
            width: 14px;
            height: 14px;
            display: inline-block;
            position: absolute;
            bottom: 13px;
            right: 10px;
          }
        }
      }
    }
  }
}
</style>